module.exports = __webpack_public_path__ + "static/media/location celeste 2.10b063ac.svg";